<template lang="pug">
div.tos
  div(v-if="$i18n.locale === 'en'")
    ToSEn
  div(v-else)
    ToSZh
  Separator(class="my-4")
  span {{$t('last-revision')}} 13/03/2026
</template>

<script setup>
import { Separator } from '@/components/ui/separator'
import ToSZh from '~/components/dif-lang/ToSZh'
import ToSEn from '~/components/dif-lang/ToSEn'
</script>

<style lang="postcss">
.tos {
  text-align: left;
  max-width: var(--secondary-max-width);
  padding: 0 1rem 3rem;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 1rem;
  }

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin-top: 3rem;
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
  }

  summary {
    display: list-item;
  }

  .tos-summary {
    margin-top: 1rem;
    border: 1px solid color-mix(in srgb, var(--secondary-color) 12%, transparent);
    border-radius: 1rem;
    background: color-mix(in srgb, var(--secondary-color) 3%, transparent);
    overflow: hidden;

    summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      cursor: pointer;
      list-style: none;
      padding: 0.9rem 1rem;
      font-weight: 600;
      line-height: 1.5;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    summary::after {
      content: '+';
      font-size: 1.2rem;
      line-height: 1;
      opacity: 0.65;
      transition: transform 0.2s ease, opacity 0.2s ease;
    }

    &[open] summary::after {
      content: '−';
      opacity: 1;
    }

    .tos-summary-body {
      padding: 0 1rem 1rem;
      border-top: 1px solid color-mix(in srgb, var(--secondary-color) 10%, transparent);

      p,
      ul {
        margin-top: 0.75rem;
      }

      ul {
        padding-left: 1.25rem;
      }
    }

    .tos-summary-note {
      font-size: 0.92rem;
      line-height: 1.7;
      opacity: 0.82;
    }
  }

  color: var(--secondary-color);
  font-size: 1rem;
  line-height: 2;

  ul {
    padding-left: 1rem;
  }
}
</style>
